<template>
<div class="app-content">
  <div class="container">
    <div class="row my-5">
      <div class="col-sm-12 mb-4">
        <h1 class="text-2xl text-gray-900 mb-8 border-b self-start">Regulament cumpărare</h1>
      </div>
      <div class="grid grid-cols-1 gap-4 mt-3 text-justify text-sm">
        <div>
          <p v-html="$t('how_buy_rules')"></p>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<style scoped>
    .swiper-slide {
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 420px !important;
    }
    .howBuyBtn {
      color: gray;
      text-align: left;
      display: block;
      padding: 10px 15px;
      border: solid 1px gray;
      margin: 5px 0;
      width:70%;
    }
    .howBuyBtn:hover {
      color: black;
      border-color: black;
    }
    .action_box, .action_box_ima {
      color: black;
      border: 1px solid gray;
      display: block;
      padding: 10px 15px;
      margin-top: 5px;
      width: 70%;
      /* For Safari 3.1 to 6.0 */
      transition: width 0.2s;
      font-size: 0.8rem;
      color: #6c757d;
      background-color: transparent;
      background-image: none;
      border-color: #6c757d;
      padding: 0.575rem 0.75rem;
      font-size: 0.9rem;
      line-height: 1.6;
    }
    @media only screen and (max-width: 992px) {
      .action_box, .action_box_ima {
        width: 100%;
      }
    }
    .action_box:hover, .action_box_ima:hover {
      color: #000;
      width: 80%;
      text-decoration: none;
      visibility: visible !important;
    }
    @media only screen and (max-width: 992px) {
      .action_box:hover, .action_box_ima:hover {
        width: 100%;
      }
    }
</style>

<script>
    import Layout from '@/Shared/Layout'
    import Dropdown from '@/Shared/Dropdown'

    import 'swiper/dist/css/swiper.css';
    import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper';

    export default {
        metaInfo() {
            return {
                title: 'Acasă',
                meta: [
                    {
                        name: 'robots',
                        content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
                    },
                    {
                        name: 'googlebot',
                        content: this.$page.app.test_environment ? 'noindex, nofollow, nosnippet, noarchive' : 'index, follow'
                    },
                    {name: 'title', content: 'Dependent de Arta - Magazinul tau de Artă!'},
                    {
                        name: 'description',
                        content: 'Magazinul tău de artă: pcituri, sculpturi, gravuri, bijuterii, ceasuri, arta decorativa si multe altele. Viziteaza-na sau cumpara online acum!'
                    },
                    {name: 'keywords', content: 'dependent de arta'},
                    // Facebook
                    {name: 'og:title', property: 'og:title', content: 'Dependent de Artă - Cel mai mare magazin de artă din România'},
                    {
                        name: 'og:description',
                        property: 'og:description',
                        content: 'Art Boutique Dependent de Artă este serviciul care vă pune la dispoziție opere de artă pentru achiziția imediată și directă'
                    },
                    {name: 'og:image', property: 'og:image', content: 'Placeholder Image Link'},
                    {name: 'og:url', property: 'og:url', content: window.location.href},
                    {name: 'og:type', property: 'og:type', content: 'website'},
                ]
            }
        },
        layout: Layout,
        components: {
            Layout,
            swiper,
            swiperSlide,
            Dropdown
        },
        props: {
            featured: Array,
            slide: Object,
            categories: Array,
            anchor: String,
        },
        data() {
            return {
                swiperOption: {
                    slidesPerView: 1,
                    loop: true,
                    speed: 200,
                    autoplay: {
                        delay: 4000,
                    },
                    spaceBetween: 30,
                    effect: 'fade',
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                },
                toggleMap: false
            }
        },
        methods: {
            addToCart(id) {
                this.$inertia.post(this.route('shop.cart.add', id), {
                    replace: false,
                    preserveState: true,
                    preserveScroll: true,
                })
            },
            scrollToTarget(target) {
                const navOffset = 100;
                const targetPosition = target.getBoundingClientRect().top;
                const offsetPosition = targetPosition - navOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            },
            currentPage() {
                return window.location.href
            },
            copyToClipboard(lot) {
                return window.navigator.clipboard.writeText(this.route('shop.lot.view', lot.slug));
            },
            showMap() {
                this.toggleMap = this.toggleMap ? false : true;
            }
        },
        mounted() {
            if (this.anchor) {
                this.scrollToTarget(this.$refs[this.anchor])
                history.replaceState('', 'Acasă', '/');
            }
        }
    }
</script>
